import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_CLIENT_API_URL;

/**
 * Hook per la gestione dell'autenticazione nel portal clienti.
 * Legge da sessionStorage con chiavi dedicate (portal_token, portal_user).
 */
export function useClientAuth() {
  const [clientData, setClientData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const raw = sessionStorage.getItem("portal_user");
    const token = sessionStorage.getItem("portal_token");

    if (!raw || !token) {
      navigate("/login", { replace: true });
      setLoading(false);
      return;
    }

    try {
      const parsed = JSON.parse(raw);
      setClientData(parsed);
    } catch {
      sessionStorage.removeItem("portal_user");
      sessionStorage.removeItem("portal_token");
      navigate("/login", { replace: true });
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  const refreshProfile = async () => {
    try {
      const res = await fetch(`${API_URL}/api/client/me`);
      if (res.ok) {
        const data = await res.json();
        setClientData(data);
        sessionStorage.setItem("portal_user", JSON.stringify(data));
      }
    } catch {
      console.error("Errore nel refresh profilo");
    }
  };

  const logout = () => {
    sessionStorage.removeItem("portal_token");
    sessionStorage.removeItem("portal_user");
    navigate("/login", { replace: true });
  };

  return { clientData, loading, logout, refreshProfile };
}
